import { setFilters } from "./helpers/filters";
import { createTodo, loadTodos } from "./helpers/todos";
import renderTodos from "./helpers/views";

renderTodos();

document.querySelector("#search-text").addEventListener("input", e => {
  setFilters({
    searchText: e.target.value
  });
  renderTodos();
});

document.querySelector("#hide-completed").addEventListener("change", e => {
  setFilters({
    hideCompleted: e.target.checked
  });
  renderTodos();
});

document.querySelector("#new-todo").addEventListener("submit", e => {
  e.preventDefault();
  let textValueOfTodo = e.target.elements.text.value;
  textValueOfTodo.trim();
  if (textValueOfTodo) {
    createTodo(textValueOfTodo);
    renderTodos();
    e.target.elements.text.value = "";
  }
});

// Adding a watcher for local storage
window.addEventListener("storage", e => {
  if (e.key === "todos") {
    loadTodos();
    renderTodos();
  }
});
